import cloneDeep from 'lodash/cloneDeep';
import { APPLICATION_TVA_TYPE_NORMAL } from '@/configuration/applicationTvaConf';

const pointDeVenteInitial = {
  srcImg: '',
  heightImg: 0,
  libelle: '',
  adresse: {},
  enseigne: '',
  idEnseigne: '',
  idGroupe: '',
  marque: '',
  icon: '',
  id: '',
  panneaux: [],
  panneauxInactifs: [],
  secteurActiviteId: '',
  code: '',
  applicationTva: APPLICATION_TVA_TYPE_NORMAL,
};

export default cloneDeep(pointDeVenteInitial);
